import {configStore} from 'app/store/global';

const getMetaContent = name => {
    const meta = document.querySelector(`meta[name="${name}"]`);

    return meta?.getAttribute('content') || '';
};

export const getRecaptchaLocale = () => configStore.CURRENT_LOCALE || getMetaContent('current-locale') || 'en';

export const getRecaptchaV2SiteKey = () => getMetaContent('Recaptcha');

export const getRecaptchaV3SiteKey = () => getMetaContent('Recaptcha_v3');
